import React from 'react'

import { Heading, ScrollList, Text } from '@hhgtech/hhg-components'

import { SingleSubot, SpotlightSubot } from 'interfaces/types'

import { StyledSpotlightSubot, StyledSpotlightSubotList } from './index.styled'

export type Props = {
  isMobile?: boolean
  spotlightSubot: SpotlightSubot
}

export type SingleSubotProps = {
  isMobile?: boolean
  subotInfo: SingleSubot
  isTheUniqueSubot?: boolean
}

const SingleSpotlightSubot = ({
  isMobile,
  subotInfo,
  isTheUniqueSubot,
}: SingleSubotProps) => {
  return (
    <StyledSpotlightSubot
      onClick={() => (window.location.href = subotInfo?.subotUrl)}
      data-is-unique-subot={isMobile && isTheUniqueSubot}
      data-event-category="Spotlight"
      data-event-action="Embedded Engage Click"
      data-event-label={subotInfo?.subotUrl}
    >
      <img src={subotInfo?.icon} alt="Subot Icon" loading="lazy" />
      <Text size="sm" type="bold">
        {subotInfo?.title}
      </Text>
    </StyledSpotlightSubot>
  )
}

const SpotlightSubotList = ({ isMobile, spotlightSubot }: Props) => {
  const scrollListColumn = isMobile ? 2 : 4

  return (
    <StyledSpotlightSubotList>
      <Heading tag="h3">{spotlightSubot?.title}</Heading>
      <div className="list-subot">
        {spotlightSubot?.post?.length <= scrollListColumn && (
          <>
            {spotlightSubot?.post?.map((subot: SingleSubot, index: number) => (
              <SingleSpotlightSubot
                key={index}
                isMobile={isMobile}
                subotInfo={subot}
                isTheUniqueSubot={
                  isMobile ? undefined : spotlightSubot?.post?.length === 1
                }
              />
            ))}
          </>
        )}

        {spotlightSubot?.post?.length > scrollListColumn && (
          <ScrollList
            key={`subot-${isMobile}`}
            row={1}
            column={scrollListColumn}
            isDotsShown={true}
            isArrowShown={!isMobile}
            className="scroll-list"
            mode={isMobile ? 'snapped' : undefined}
          >
            {spotlightSubot?.post?.map((subot: SingleSubot, index: number) => (
              <SingleSpotlightSubot
                key={index}
                isMobile={isMobile}
                subotInfo={subot}
              />
            ))}
          </ScrollList>
        )}
      </div>
    </StyledSpotlightSubotList>
  )
}

export { SpotlightSubotList, SingleSpotlightSubot }
